module.exports = __webpack_public_path__ + "img/icon_service@2x.dea87f92.png";